import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "../assets/css/bank-modal.css";

export default function BaseModal({
  isOpen,
  title,
  children,
  onClose,
  size = "md",
  footer = null,
  headerAction = null,
  showClose = true,
  headerExtra = null,
  icon = null,
}) {
  /* =========================
     SCROLL LOCK ONLY
  ========================= */
  useEffect(() => {
    if (!isOpen) return;

    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="modal-overlay">
      <div
        className={`bank-modal bank-modal-${size}`}
        role="dialog"
        aria-modal="true"
      >
        {/* ================= HEADER ================= */}
        <div className="bank-modal-header">
          <div className="bank-modal-header-top">
            <div className="bank-modal-title-wrap">
              {icon && <div className="modal-icon">{icon}</div>}
              <h3 className="bank-modal-title">{title}</h3>
            </div>

            <div className="bank-modal-header-right">
              {headerAction}

              {showClose && (
                <button
                  className="modal-close-btn"
                  onClick={onClose}
                  type="button"
                >
                  ✕
                </button>
              )}
            </div>
          </div>

          {headerExtra && (
            <div className="bank-modal-header-extra">
              {headerExtra}
            </div>
          )}
        </div>

        {/* ================= BODY ================= */}
        <div className="bank-modal-body">
          {children}
        </div>

        {/* ================= FOOTER ================= */}
        {footer && (
          <div className="bank-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}